<template>
  <ion-app>
    <Menu></Menu>
  </ion-app>
</template>

<script>
import {alertController, IonApp, toastController} from "@ionic/vue";
import {defineComponent} from "vue";
import Menu from "./components/Menu.vue";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import * as icon from "ionicons/icons";
import {addIcons} from "ionicons";
import {PushNotifications} from "@capacitor/push-notifications";

import {Badge} from "@capawesome/capacitor-badge";

import {FCM} from "@capacitor-community/fcm";
import {isPlatform} from "@ionic/vue";
import axios from "axios";
import moment from "moment";
import {StatusBar} from "@capacitor/status-bar";
import {LocalNotifications} from "@capacitor/local-notifications";
//import { SplashScreen } from '@capacitor/splash-screen';
import {App} from '@capacitor/app';

const config = require("@/config");
const PusherJS = require('pusher-js');

addIcons({"sync-outline": icon.syncOutline});
addIcons({"bulb-outline": icon.bulbOutline});
addIcons({"time-outline": icon.timeOutline});
addIcons({"calendar-outline": icon.calendarOutline});
addIcons({"people-outline": icon.peopleOutline});
addIcons({"heart-half-outline": icon.heartHalfOutline});
addIcons({"help-outline": icon.helpOutline});
addIcons({"globe-outline": icon.globeOutline});
addIcons({"notifications-outline": icon.notificationsOutline});
addIcons({"qr-code": icon.qrCode});
addIcons({scan: icon.scan});
addIcons({"chevron-down": icon.chevronDown});

export default defineComponent({
  name: "App",
  components: {
    IonApp,
    Menu,
  },
  data() {
    return {
      updateInterval: null,
      toast: null,
      //fcm: new FCM()
      browserName: null,
      consent_disclaimer: "",
      messageChannel: null,
      meetingChannel: null,
      leadChannel: null,
    };
  },

  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("news", ["newsNumber"]),
    ...mapState("sync", [
      "updateFinished",
      "syncActive",
      "downloadSize",
      "downloadLabel",
      "currentProgress",
    ]),
    ...mapState("personalDB", ["unreadNews"]),
    ...mapState("sessions", ["activeSessions"]),
    ...mapState("currentConference", [
      "currentConference",
      "fullName",
      "shortName",
      "apiVersion",
    ]),
    ...mapState("wordings", ["wordings", "currentLanguage"]),

    ...mapState("chat", ["chatUser"]),

  },
  methods: {
    ...mapActions("sync", ["start", "showSyncToast"]),

    ...mapMutations("pushmessages", ["addMessage"]),
    ...mapMutations("news", ["addNewsNumber"]),
    ...mapActions("settings", ["getSetting"]),
    ...mapMutations("googleanalytics", ["setVM"]),
    ...mapActions("chat", [
      "getRoomList",
      "getUnreadMessagesTotalCount",
      "markMessageAsRead",
    ]),
    ...mapActions("personalDB", ["getItem", "setTime", "getUnreadNews"]),
    ...mapMutations("personalDB", ["setUnreadNews"]),
    ...mapMutations("sessions", ["setActiveSessions"]),

    ...mapActions("messages", ["saveMessage"]),
    ...mapActions("cmetracking", ["uploadTrackingEvents", "trackEvent"]),

    trackUserEvent(item, event, type) {
      let trackData = {
        user: this.user,
        item: item,
        event: event,
        type: type,
        itemId: item.id || this.guid(),
      };
      this.trackEvent(trackData);

      if (item && item.data) {
        axios.post("https://push.mobile.documedias.systems/message_status/", {
          conference: item.data.conference || this.currentConference,
          message_id:
              item && item.data && item.data.messId
                  ? item.data.messId
                  : item.data.message_id,
          status: event,
          user: this.user && this.user.id ? this.user.id : 0
        });
      } else {
        axios.post("https://push.mobile.documedias.systems/message_status/", {
          conference: this.currentConference,
          message_id: item.id,
          status: event,
          user: this.user && this.user.id ? this.user.id : 0
        });
      }
    },

    async showUpdateToast() {
      this.toast = await toastController.create({
        message: "A new version is available",
        position: "bottom",
        duration: 2000,
        animated: "true",
        buttons: [
          {
            side: "start",
            icon: "star",
            text: "Update",
            handler: async () => {
              this.toast.dismiss();
              let res = await this.start();
              if (res) {
                this.showSyncToast();
                //this.$router.go();
              }
            },
          },
          {
            text: "Done",
            role: "cancel",
            handler: () => {
              console.log("Cancel clicked");
            },
          },
        ],
      });
      return this.toast.present();
    },

//TODO: for society config.full_name instead of this.currentconference
    async checkAppVersion() {
      let versionOk = true;
      let app_versions = (
          await axios.get(
              "https://mantel-api.mobile.documedias.systems/v2/conferences/" +
              this.currentConference +
              "/app_versions"
          )
      ).data;
      console.log("appversions", app_versions);
      if (isPlatform("ios")) {
        let iosVersions = app_versions.filter((v) => v.platform == "ios");
        if (iosVersions) {
          iosVersions = iosVersions.sort((a, b) => {
            return new Date(b.created_at) - new Date(a.created_at);
          });
          let versionToCheck = iosVersions[0];
          versionOk = versionToCheck ? versionToCheck.version == config.versionIOS : false;
        }
      }
      if (isPlatform("android")) {
        let androidVersions = app_versions.filter(
            (v) => v.platform == "android"
        );
        if (androidVersions) {
          androidVersions = androidVersions.sort((a, b) => {
            return new Date(b.created_at) - new Date(a.created_at);
          });
          let versionToCheck = androidVersions[0];
          versionOk = versionToCheck ? versionToCheck.version == config.versionAndroid : false;
        }
      }
      console.log('appversion', versionOk)

      if (!versionOk) {
        this.toast = await toastController.create({
          message: "A new version is available in the App Store",
          position: "bottom",
          animated: "true",
          buttons: [
            {
              side: "start",
              icon: "star",
              text: "Update",
              handler: async () => {
                this.toast.dismiss();
                let url = "https://apps.documedias.com/" + config.short_name;
                alert(url)
                window.location.href = url;
              },
            },
            {
              text: "Done",
              role: "cancel",
              handler: () => {
                console.log("Cancel clicked");
              },
            },
          ],
        });
        return this.toast.present();
      }
    },

    //LOCAL NOTIFICATIONS METHODS
    async registerLocalNotificationTypes() {
      await LocalNotifications.registerActionTypes({
        types: [
          {
            id: "your_choice",
            actions: [
              {
                id: "dismiss",
                title: "Dismiss",
                destructive: true,
              },
              {
                id: "open",
                title: "Open app",
              },
              {
                id: "respond",
                title: "Respond",
                input: true,
              },
            ],
          },
        ],
      });
    },

    async addLocalListeners() {
      await LocalNotifications.addListener(
          "localNotificationActionPerformed",
          async (notification) => {
            console.log(
                "Notification action received",
                notification.actionId,
                notification
            );
            let msgToSave = {
              message: {
                id: this.guid(),
                created_at: moment().utc(true).toISOString(),
                title: notification.notification.title,
                content: notification.notification.body,
                read: false,
                redirect:
                    notification.notification &&
                    notification.notification.extra &&
                    notification.notification.extra.redirect
                        ? notification.notification.extra.redirect
                        : null,
                system_message: true,
              },
              count: 1,
            };
            await this.saveMessage(msgToSave);

            if (
                notification.notification &&
                notification.notification.extra &&
                notification.notification.extra.redirect
            ) {
              this.$router.push(notification.notification.extra.redirect);
            }
          }
      );
    },

    //PUSH NOTIFICATIONS METHODS

    async addListeners() {
      await PushNotifications.addListener("registration", (token) => {
        console.log('token received', token)
        //send to server

        let params = {};
        let platform = "web";
        let version = "";

        if (isPlatform("ios")) {
          platform = "ios";
          version = config.versionIOS;
        }

        if (isPlatform("android")) {
          platform = "android";
          version = config.versionAndroid;
        }

        params = {type: platform, token: token.value, version: version};

        if (this.user) {
          if (this.user.id) {
            axios.post("https://push.mobile.documedias.systems/subscribe/", {
              conference: this.currentConference,
              user: this.user.id,
              platform: params.type,
              token: params.token,
              application: this.fullName,
              app_version: params.version,
            });
          }
        } else {
          axios.post("https://push.mobile.documedias.systems/subscribe/", {
            conference: this.currentConference,
            platform: params.type,
            token: params.token,
            application: this.fullName,
            app_version: params.version,
          });
        }
      });

      await PushNotifications.addListener("registrationError", (err) => {
        console.error("Registration error: ", err.error);
      });

      await PushNotifications.addListener(
          "pushNotificationReceived",
          (notification) => {
            //alert(notification)
            let nowTime = moment().toISOString();
            let msg = {
              time: nowTime, //moment
              content: notification.body || notification.data.body,
              redirect: notification.data.redirect || "/app/posts/",
              linkText: "Go to news",
              //from: message.userFrom.firstname + ' ' + message.userFrom.lastname,
              //avatar: message.userFrom.avatar_id ? 'https://fileserver.documedias.systems/file/' + message.userFrom.avatar_id + '/face/130/130' : '',
              message: {
                title: notification.title,
              },
            };

            this.trackUserEvent(notification, "received", "push");
            console.log(msg);
            //this.addMessage(msg)
          }
      );

      await PushNotifications.addListener(
          "pushNotificationActionPerformed",
          (notification) => {
            console.log(
                "Push notification action performed",
                notification.actionId,
                notification.inputValue
            );

            this.trackUserEvent(notification.notification, "opened", "push");

            this.$router.push(
                notification.notification.data.redirect || "/app/posts/"
            );
          }
      );
    },

    async registerNotifications() {
      let permStatus = await PushNotifications.checkPermissions();

      if (permStatus.receive === "prompt") {
        permStatus = await PushNotifications.requestPermissions();
      }

      if (permStatus.receive !== "granted") {
        console.log("User denied permissions!");
      }

      await PushNotifications.register();
    },

    async getDeliveredNotifications() {
      const notificationList =
          await PushNotifications.getDeliveredNotifications();
      console.log("delivered notifications", notificationList);
    },

    async clearAllDeliveredNotifications() {
      if (isPlatform("mobile") && config.is_app) {
        await Badge.clear();
      }
    },

    guid() {
      // http://www.ietf.org/rfc/rfc4122.txt
      let s = [];
      let hexDigits = "0123456789abcdef";
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      return s.join("");
    },
    async showConsentDisclaimer() {
      let choice;
      const alert = await alertController.create({
        cssClass: "consent-disclaimer",
        message: "<strong>" + this.consent_disclaimer + "</strong>",
        buttons: [
          {
            text: "Decline",
            role: "cancel",
            cssClass: "secondary",
            id: "cancel-button",
            handler: (blah) => {
              localStorage.setItem("consentGiven", "false");
            },
          },
          {
            text: "Accept",
            id: "confirm-button",
            handler: () => {
              localStorage.setItem("consentGiven", "true");
            },
          },
        ],
      });
      return alert.present();
    },

    subscribeToChannels() {

      console.log('CHAT USER NEU GESETZT SUBSCRIBE SOCKET')
      if (!this.chatSocket) return;

      if (this.user && this.user.id) {
        if (this.meetingChannel) {
          this.messageChannel.unbind_all();
          this.chatSocket.unsubscribe(this.meetingChannel.name)
        }
        this.meetingChannel = this.chatSocket.subscribe("chat.meeting." + this.currentConference + "." + this.user.id)
        this.meetingChannel.bind("chat.meetingto", (meeting) => {
          console.log("incoming meeting", meeting);
          let message = meeting.message;
          message.is_request = true;
          let fromusr = JSON.parse(message.from_user);
          message.title =
              this.wordings[this.currentLanguage].NEW_MEETING_REQUEST +
              " " +
              fromusr.firstname +
              " " +
              fromusr.lastname;
          console.log(message);
          this.addMessage(message);
        });


        if (this.leadChannel) {
          this.leadChannel.unbind_all();
          this.chatSocket.unsubscribe(this.leadChannel.name)
        }
        this.leadChannel = this.chatSocket.subscribe("chat.lead." + this.currentConference + "." + this.user.id);
        this.leadChannel.bind("chat.lead", (lead) => {
          console.log("incoming lead", lead);
          let message = lead.lead;
          message.is_contact = true;
          this.addMessage(message);
        });


        if (this.messageChannel) {
          this.messageChannel.unbind_all();
          this.chatSocket.unsubscribe(this.messageChannel.name)
        }
        this.messageChannel = this.chatSocket.subscribe("chat.message." + this.currentConference + "." + this.user.id);
        this.messageChannel.bind("chat.message", async (message) => {
          console.log("user recevied", message);

          let is_in_same_room =
              location.hash == "#/app/chats/" + message.message.room_id;
          if (message.userFrom.id != this.user.id) {
            if (location.hash == "#/app/chat") {
              this.getUnreadMessagesTotalCount();
            }
            if (location.hash == "#/app/mychats") {
              this.getUnreadMessagesTotalCount();
            }

            if (!is_in_same_room) {
              let msg = {
                id: message.message.id,
                time: message.message.created_at,
                content: message.message.text,
                redirect: "/app/chats/" + message.message.room_id,
                linkText: "go to chat",
                from:
                    message.userFrom.firstname + " " + message.userFrom.lastname,
                avatar: message.userFrom.avatar_id
                    ? "https://fileserver.documedias.systems/file/" +
                    message.userFrom.avatar_id +
                    "/face/130/130"
                    : "",
                message: {
                  title: "", //message.userMessage.user_id''
                },
              };

              this.getUnreadMessagesTotalCount();
              this.addMessage(msg);

              let msgToSave = {
                message: {
                  id: this.guid(),
                  created_at: moment().utc(true).toISOString(),
                  title: "New message from " + msg.from,
                  content: null,
                  read: false,
                  redirect: msg.redirect,
                  system_message: true,
                },
                count: 1,
              };
              await this.saveMessage(msgToSave);

              console.log("CHAT MESSAGE", msg, msgToSave);
            } else {
              //this.getUnreadMessagesTotalCount();

              await this.markMessageAsRead(message.message.id);
              //TODO:set message read
              await this.getRoomList();
            }
          }

        });
      }
    },


    subscribeToChannels2() {

      console.log('CHAT USER NEU GESETZT SUBSCRIBE SOCKET')
      this.meetingChannel = this.chatSocket.subscribe("chat.meeting." + this.currentConference + "." + this.user.id)
      this.meetingChannel.bind("chat.meetingto", (meeting) => {
        console.log("incoming meeting", meeting);
        let message = meeting.message;
        message.is_request = true;
        let fromusr = JSON.parse(message.from_user);
        message.title =
            this.wordings[this.currentLanguage].NEW_MEETING_REQUEST +
            " " +
            fromusr.firstname +
            " " +
            fromusr.lastname;
        console.log(message);
        this.addMessage(message);
      });
      this.leadChannel = this.chatSocket.subscribe("chat.lead." + this.currentConference + "." + this.user.id);
      this.leadChannel.bind("chat.lead", (lead) => {
        console.log("incoming lead", lead);
        let message = lead.lead;
        message.is_contact = true;
        this.addMessage(message);
      });
      this.messageChannel = this.chatSocket.subscribe("chat.message." + this.currentConference + "." + this.user.id);
      this.messageChannel.bind("chat.message", async (message) => {
        console.log("user recevied", message);

        let is_in_same_room =
            location.hash == "#/app/chats/" + message.message.room_id;
        if (message.userFrom.id != this.user.id) {
          if (location.hash == "#/app/chat") {
            this.getUnreadMessagesTotalCount();
          }
          if (location.hash == "#/app/mychats") {
            this.getUnreadMessagesTotalCount();
          }

          if (!is_in_same_room) {
            let msg = {
              id: message.message.id,
              time: message.message.created_at,
              content: message.message.text,
              redirect: "/app/chats/" + message.message.room_id,
              linkText: "go to chat",
              from:
                  message.userFrom.firstname + " " + message.userFrom.lastname,
              avatar: message.userFrom.avatar_id
                  ? "https://fileserver.documedias.systems/file/" +
                  message.userFrom.avatar_id +
                  "/face/130/130"
                  : "",
              message: {
                title: "", //message.userMessage.user_id''
              },
            };

            this.getUnreadMessagesTotalCount();
            this.addMessage(msg);

            let msgToSave = {
              message: {
                id: this.guid(),
                created_at: moment().utc(true).toISOString(),
                title: "New message from " + msg.from,
                content: null,
                read: false,
                redirect: msg.redirect,
                system_message: true,
              },
              count: 1,
            };
            await this.saveMessage(msgToSave);

            console.log("CHAT MESSAGE", msg, msgToSave);
          } else {
            //this.getUnreadMessagesTotalCount();

            await this.markMessageAsRead(message.message.id);
            //TODO:set message read
            await this.getRoomList();
          }
        }
      });
    },
    async setupAppStateListener() {
      App.addListener('appStateChange', async ({isActive}) => {
        if (!isActive) {
          console.log('to background');
        } else {
          console.log('from background');
          if (!this.chatSocket || this.chatSocket.connection.state !== 'connected') {
            console.log('Reconnecting to Pusher...')
            this.connectPusher()
          }

          this.subscribeToChannels();
          this.getUnreadMessagesTotalCount();
        }
      });
    },


    connectPusher() {
      if (this.chatSocket) {
        this.chatSocket.disconnect()
      }
      this.chatSocket = new PusherJS('pezsxnz54a35jjhc', {
        wsHost: 'broadcaster.documedias.systems',
        wsPort: 443,
        httpHost: '127.0.0.1',
        httpPort: 8030,
        forceTLS: false,
        encrypted: true,
        disableStats: true,
        reconnect: true,
        pong_timeout: 30000,  // 30 seconds ping timeout
        activity_timeout: 25,
        enabledTransports: ['ws', 'wss'],
        authEndpoint: 'http://localhost:8030/api/broadcasting/auth',
        auth: {
          headers: {
            'x-api-key': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMS0wNC0xNVQwNTo0Mjo0MS41MTBaIiwiaWQiOjcsImlhdCI6MTYxODQ2NTM2MX0.0ssQOrA2s-KcaURqKXhuAMRKySfTL6rCCQximtUZfgg',
          }
        }
      });
    }
  },
  mounted() {
    this.$socketInt.on("connect", () => {
      console.log("connected interactive");
    });

    this.pushSocket.on("connect", () => {
      console.log('sockInt reconnect')
    });


    this.chatSocket.connection.bind('state_change', ({previous, current}) => {
      console.log(`Pusher state changed from ${previous} to ${current}`);
    });
    this.chatSocket.connection.bind('connected', () => {
      console.log('Pusher connected');
      //this.subscribeToChannels()
    });

    this.chatSocket.connection.bind('disconnected', () => {
      console.warn('Pusher disconnected');
    });

    this.chatSocket.connection.bind('error', (err) => {
      console.error('Pusher connection error:', err);
    });

    this.chatSocket.connection.bind('unavailable', () => {
      console.error('Pusher connection unavailable');
    });

    this.chatSocket.connection.bind('connecting_in', (delay) => {
      console.log(`Reconnecting in ${delay}s`);
    });
    if (this.user && this.user.id) {

      this.chatSocket
          .subscribe(
              "chat.meeting." + this.currentConference + "." + this.user.id
          )
          .bind("chat.meetingto", (meeting) => {
            console.log("incoming meeting", meeting);
            let message = meeting.message;
            message.is_request = true;
            let fromusr = JSON.parse(message.from_user);
            message.title =
                this.wordings[this.currentLanguage].NEW_MEETING_REQUEST +
                " " +
                fromusr.firstname +
                " " +
                fromusr.lastname;
            console.log(message);
            this.addMessage(message);
          });
      this.chatSocket
          .subscribe("chat.lead." + this.currentConference + "." + this.user.id)
          .bind("chat.lead", (lead) => {
            console.log("incoming lead", lead);
            let message = lead.lead;
            message.is_contact = true;
            this.addMessage(message);
          });

      this.chatSocket
          .subscribe(
              "chat.message." + this.currentConference + "." + this.user.id
          )
          .bind("chat.message", async (message) => {
            console.log("user recevied", message);

            let is_in_same_room =
                location.hash == "#/app/chats/" + message.message.room_id;
            if (message.userFrom.id != this.user.id) {
              if (location.hash == "#/app/chat") {
                this.getUnreadMessagesTotalCount();
              }
              if (location.hash == "#/app/mychats") {
                this.getUnreadMessagesTotalCount();
              }

              if (!is_in_same_room) {
                let msg = {
                  id: message.message.id,
                  time: message.message.created_at,
                  content: message.message.text,
                  redirect: "/app/chats/" + message.message.room_id,
                  linkText: "go to chat",
                  from:
                      message.userFrom.firstname + " " + message.userFrom.lastname,
                  avatar: message.userFrom.avatar_id
                      ? "https://fileserver.documedias.systems/file/" +
                      message.userFrom.avatar_id +
                      "/face/130/130"
                      : "",
                  message: {
                    title: "", //message.userMessage.user_id''
                  },
                };

                this.getUnreadMessagesTotalCount();
                this.addMessage(msg);

                let msgToSave = {
                  message: {
                    id: this.guid(),
                    created_at: moment().utc(true).toISOString(),
                    title: "New message from " + msg.from,
                    content: null,
                    read: false,
                    redirect: msg.redirect,
                    system_message: true,
                  },
                  count: 1,
                };
                await this.saveMessage(msgToSave);

                console.log("CHAT MESSAGE", msg, msgToSave);
              } else {
                //this.getUnreadMessagesTotalCount();

                await this.markMessageAsRead(message.message.id);
                //TODO:set message read
                await this.getRoomList();
              }
            }
          });

      this.getUnreadMessagesTotalCount();
    }
  },
  async created() {
    this.setVM(this);
    if (!localStorage.getItem("uuid")) {
      localStorage.setItem("uuid", this.guid());
    }
    this.$socketInt.emit("join", this.currentConference);
    this.$socketInt.emit("getActiveSessions", {
      congressId: this.currentConference,
    });
    //TODO:join pushSocket
    this.pushSocket.emit("join", this.currentConference + "");

    if (isPlatform("mobile") && config.is_app) {
      await LocalNotifications.requestPermissions(); //request local notifications permission
      await this.addLocalListeners();

      await this.registerLocalNotificationTypes();
      //test
      /*
     LocalNotifications.schedule({
      notifications: [
        {
          title: "Test Title",
          body: "Test Body",
          id: 1,
          schedule: {
            at: new Date(Date.now() + 1000 * 60), // in a minute
            repeats: true,
            every: "minute",
            allowWhileIdle: true,
          }
        }
      ]
    });
*/
      await this.addListeners();
      await this.registerNotifications();
      await this.setupAppStateListener()
      PushNotifications.removeAllDeliveredNotifications();
      await this.clearAllDeliveredNotifications();

      await StatusBar.show();
      //SplashScreen.hide();
    }
    //executing push notification methods
    try {
      let res = await this.start();
      if (res) {
        this.showSyncToast();
        //this.$router.go();
        let time = await this.getItem("timeStamps_" + this.currentConference);
        console.log("time app", time);
        await this.setTime({
          name: "timeStamps_" + this.currentConference,
          item: time,
        });
        await this.getUnreadNews("posts");
        await this.uploadTrackingEvents();
      }
    } catch (err) {
      console.log(err);
    }

    if (isPlatform("mobile") && config.is_app) {
      await this.getDeliveredNotifications();
      FCM.getToken()
          .then((r) => console.log(`Token ${r.token}`))
          .catch((err) => console.log(err));
    }

    this.$socketInt.on("triggerUpdate", (data) => {
      console.log("updateMessage", data);
      this.showUpdateToast();
    });

    this.$socketInt.on("getActiveSessions", (data) => {
      console.log("sessions", data);
      this.setActiveSessions(data);
      if (data.length > 0) {
        //this.showSyncToast();
      }
    });

    //TODO:add subscriber
    this.pushSocket.on("pushreceived", (msg) => {
      msg.redirect = "/app/posts/"; //
      msg.linkText = "Go to news"; //

      console.log("push received", msg);

      this.trackUserEvent(msg, "received", "push");
      this.addMessage(msg);
      setTimeout(() => {
        this.setUnreadNews(this.unreadNews + 1);
      }, 1000);
    });

    this.chat_enabled = await this.getSetting("chat_enabled");
    console.log("chat available", this.chat_enabled);

    this.video_chat_enabled = await this.getSetting("chat_enabled");
    console.log("video chat available", this.video_chat_enabled);

    this.consent_disclaimer = await this.getSetting("consent_disclaimer");
    /*let consentAnswered = localStorage.getItem('consentAnswered');
    if (!consentAnswered) {
      await this.showConsentDisclaimer();
    }*/

    await this.checkAppVersion();
  },

  watch: {

    'user.id': {
      handler(val) {
        //const id = val?.id;
        if (val) {
          console.log('id changed to', val);
          this.subscribeToChannels();
        } else {
          console.log('id not existing')
        }

      },
      immediate: true
    },
    updateFinished: async function (newVal) {
      if (newVal) {
        //UPDATE REMINDER EVERY HOUR
        let self = this;
        if (this.updateInterval) {
          clearInterval(this.updateInterval);
        }
        this.updateInterval = setInterval(() => {
          if (this.toast) {
            this.toast.dismiss();
          }

          self.showUpdateToast();
        }, 3600000);
      }
    },
    $route: {
      immediate: true,
      async handler() {
        if (this.chatSocket.connection.state !== 'connected') {
          this.chatSocket.connect();
        }
      },
    },
  },
});
</script>


<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import "./assets/styles/ionicons.css";
@import "./assets/styles/modern.scss";
@import "./assets/styles/dashboard.scss";
@import "./assets/styles/videochat.scss";
@import "./assets/styles/exhibitor.scss";
@import "./assets/styles/martin.scss";
@import "./assets/styles/requests.scss";
@import "./assets/styles/profile.scss";
@import "./assets/styles/polls.scss";
@import "./assets/styles/meetingsgrid.scss";

@import "./assets/styles/changebrowser.scss";
@import "./assets/styles/brand.scss";

@font-face {
  font-family: "documedias-icons";
  src: url("./assets/fonts/documedias-icons.eot?y5ed3m");
  src: url("./assets/fonts/documedias-icons.eot?y5ed3m#iefix") format("embedded-opentype"),
  url("./assets/fonts/documedias-icons.ttf?y5ed3m") format("truetype"),
  url("./assets/fonts/documedias-icons.woff?y5ed3m") format("woff"),
  url("./assets/fonts/documedias-icons.svg?y5ed3m#icomoon") format("svg");
  font-weight: normal;
  font-style: normal;
}

.icon-sponsor,
.icon-aussteller {
  font-family: "documedias-icons";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.4rem !important;
}

.icon-sponsor:before {
  content: " \e904 ";
}

.icon-aussteller:before {
  content: " \e903 ";
}

ion-content {
  --padding-start: env(safe-area-inset-left); /* Apply safe area */
  --padding-end: env(safe-area-inset-right);
}

body.scanner-active {
  .scanlist-banner {
    display: none;
  }

  ion-app {
    background: transparent !important;
  }

  --background: transparent;
  --ion-background-color: transparent;

  .ion-page {
    background: transparent !important;

    ion-content {
      display: none;
    }

    .conf2go-controls {
      display: none;
    }

    .scan-controls {
      display: block;
    }
  }

  .qr-button {
    display: none;
  }

  .day-selector {
    display: none;
  }

  .sessionlist-searchbar {
    display: none;
  }
}
</style>
